export const dashbaordFrequencies = {
  TODAY: "1D",
  WEEK: "7D",
  MONTH: "1M",
  THREEMONTHS: "3M"
};

export const dateFormats = {
  DISPLAY_DATE: "DD-MMM-YYYY",
  DISPLAY_DATE_TIME: "DD-MMM-YYYY HH:MM:SS",
  DATE_FORMAT: "DD-MMM-YY",
  DATE_TIME_FORMAT: "DD-MMM-YYYY HH:mm:ss",
  DATE_HOUR: "HH:00"
};

export const emailStatus = {
  VALID: "valid",
  INVALID: "invalid",
  UNKNOWN: "unknown",
  GOOD: "good",
  BAD: "bad",
  INPROCESS: "inprocess"
};



// WEBPACK FOOTER //
// ./src/utility/enums.js